export const contactUs = '/user/contact-us';
export const changeCurrency = '/user/update-default-currency';
export const getNotifications = '/notifications';
export const getPayeeDetails = '/payee/payee-details';
export const joinTeamRequest = "/teams/joinTeamRequest"
